import React from 'react';
import routes from '../../model/router';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
    Layout, Menu, Breadcrumb, Icon,Card,
  } from 'antd';
import '../../assets/css/App.css';
import Header1 from '../public';

const {
    Header, Content, Footer, Sider,
  } = Layout;
const SubMenu = Menu.SubMenu;
const { Meta } = Card;

class InternDoctors extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div>
                <div>
                  <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['4']}
                    defaultOpenKeys={['sub2']}
                    style={{ height: '100%' }}
                  >
                  <SubMenu key="sub1" title={<span><Icon type="user" />Staff</span>}>
                      <Menu.Item key="1"><Link to="/director">Director</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/member">Member</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub2" title={<span><Icon type="user" />Students</span>}>
                      <Menu.Item key="3"><Link to="/graduates">Graduates</Link></Menu.Item>
                      <Menu.Item key="4"><Link to="/intern-doctors">Intern doctors</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                  <Content style={{ padding: '200 200px', minHeight: 280 }}>

                    <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                      <Card
                        hoverable
                        style={{width:240}}
                        cover={<img src={require('../../assets/images/yhc.jpg')}/>}>
                        <Meta
                          title="Yuheng Chen"
                          description="Radiology CMU"
                        />
                      </Card>,
                      </div>

                      <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                      <Card
                        hoverable
                        style={{ width: 240}}
                        cover={<img src={require('../../assets/images/JYX.jpg')}/>}>
                        <Meta
                          title="Jiayi Xie"
                          description="Radiology CMU"
                        />
                      </Card>,
                          </div>                    
                          <div style={{clear:"both"}}></div>  {/*每隔2个加一句 */}


                      <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                      <Card
                        hoverable
                        style={{ width: 240}}
                        cover={<img src={require('../../assets/images/zfy.jpg')}/>}>
                        <Meta
                          title="Zifan You"
                          description="Radiology CMU"
                        />
                      </Card>,
                      </div>
                        

                      <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                      <Card
                        hoverable
                        style={{ width: 240}}
                        cover={<img src={require('../../assets/images/xqz.jpg')}/>}>
                        <Meta
                          title="Xiaoqi Zhao"
                          description="Radiology CMU"
                        />
                      </Card>,
                          </div>                       
                          <div style={{clear:"both"}}></div>  {/*每隔2个加一句 */}


                      <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                      <Card
                        hoverable
                        style={{ width: 240}}
                        cover={<img src={require('../../assets/images/qlh.jpg')}/>}>
                        <Meta
                          title="Qinlai Huang"
                          description="Medical Informatics CMU and University of Electronic Science and Technology"
                        />
                      </Card>,
                          </div>


                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                      <Card
                        hoverable
                        style={{ width: 240}}
                        cover={<img src={require('../../assets/images/myh.jpg')}/>}>
                        <Meta
                          title="Mingyue Hao"
                          description="Medical Informatics CMU"
                        />
                      </Card>,
                          </div>
                          <div style={{clear:"both"}}></div>  {/*每隔2个加一句 */}


                          <div style={{float:"left",paddingLeft:200,paddingTop:100}}>
                      <Card
                        hoverable
                        style={{ width: 240}}
                        cover={<img src={require('../../assets/images/msy.jpg')}/>}>
                        <Meta
                          title="Mingshu Yang"
                          description="Medical Informatics CMU"
                        />
                      </Card>,
                          </div>
                          
                        </Content>
                    </Layout>
            </Content>
            </div>
            </div>
        )
    }
}
export default InternDoctors;